import Client from '@/client'

export default {
  list() {
    return Client.get(`techniques/`)
  },
}